import React, { useContext } from 'react'
import * as Header from "./headerStyles"
import { FaBars, FaRegWindowClose } from "react-icons/fa"
import { SidebarContext } from "../../context/sidebarContext";



export default function BurgerMenu() {
    const { sidebar, showSidebar } = useContext(SidebarContext)
    
    return (
        <Header.Group>
            <Header.BurgerMenu onClick={showSidebar}>
                <FaBars  /> 
            </Header.BurgerMenu>
            <Header.NavMenuBehind active={sidebar} onClick={showSidebar}/>
            <Header.NavMenu active={sidebar}>
                <Header.MenuExitContainer>
                    <FaRegWindowClose  onClick={showSidebar}/>
                </Header.MenuExitContainer>
                <Header.MenuItemListContainer>
                    <Header.MenuItemContainer>
                        <Header.MenuItemNumber>01.</Header.MenuItemNumber>
                        <Header.MenuItemName href="#about">About</Header.MenuItemName>
                    </Header.MenuItemContainer>
                    <Header.MenuItemContainer>
                        <Header.MenuItemNumber>02.</Header.MenuItemNumber>
                        <Header.MenuItemName href="#projects">Projects</Header.MenuItemName>
                    </Header.MenuItemContainer>
                    <Header.MenuItemContainer>
                        <Header.MenuItemNumber>03.</Header.MenuItemNumber>
                        <Header.MenuItemName  href="#contact">Contact</Header.MenuItemName>
                    </Header.MenuItemContainer>
                </Header.MenuItemListContainer>
            </Header.NavMenu>
        </Header.Group>
    )
}
